import React from 'react';
import NotificationsLayout from './notifications-layout';

export default class Notifications extends React.Component<{}, {}> {
    render(){
        return(
            <NotificationsLayout/>
        )
    }
}